import * as firebase from 'firebase'
import db from '@/db'
import { firestoreAction } from 'vuexfire'

const userRef = db.collection('users')
const updated = firebase.default.firestore.FieldValue.serverTimestamp()

const state = {
  users: {},
  userLoading: true
}

const mutations = {
  SET_USER_LOADING (state, loading) {
    state.userLoading = loading
  }
}

const actions = {
  setUsersRef: firestoreAction(({ bindFirestoreRef, dispatch, commit }, ref) => {
    bindFirestoreRef('users', ref).then(response => {
      const org = state.users.selectedOrganization
      if (org) {
        const organizationRef = db.collection('organization').doc(org)
        dispatch('setOrganizationRef', organizationRef)
      }
      dispatch('toggleLoading', false)
      commit('SET_USER_LOADING', false)
    }).catch(error => {
      console.log(error)
    })
  }),
  addUser: ({ dispatch }, payload) => {
    const user = firebase.default.auth().currentUser
    const newUser = {
      displayName: user.displayName,
      avatar: user.photoURL,
      email: user.email,
      created: updated,
      updated: updated,
      changelog: {},
      deactivated: false,
      selectedOrganization: false
    }
    if (payload) {
      newUser.redirect = payload
    }
    const me = userRef.doc(user.uid)
    me.set(newUser).then(response => {
      dispatch('setUsersRef', me).then(response => {
        dispatch('saveState', true)
      }).catch(error => {
        console.log(error)
      })
    }).catch(error => {
      console.log(error)
    })
  },
  sawChangelog: ({ dispatch }, payload) => {
    const user = { ...payload.user }
    if (!user.changelog) {
      user.changelog = {}
    }
    user.uid = firebase.default.auth().currentUser.uid
    user.changelog[payload.notice] = new Date()
    dispatch('editUser', user)
  },
  editUser: ({ dispatch }, payload) => {
    const user = { ...payload }
    user.updated = updated
    if (!user.changelog) {
      user.changelog = {}
    }
    userRef.doc(payload.uid).update(user).then(item => {
      dispatch('saveState', true)
    }).catch(error => {
      console.log(error)
    })
  },
  checkUser: ({ dispatch, rootState, rootGetters }, payload) => {
    console.log('checking user')
    const uid = payload.user
    const ref = userRef.doc(uid)
    const redirect = payload.redirect
    ref.get().then(person => {
      if (person.exists) {
        dispatch('setUsersRef', ref).then(response => {
          if (redirect) {
            const update = { ...rootState.user }
            update.redirect = redirect
            dispatch('editUser', update)
          }
        }).catch(error => {
          console.log(error)
        })
      } else {
        dispatch('addUser', redirect)
      }
    }).catch(error => {
      console.log(error)
    })
  },
  setRedirect: ({ dispatch }, payload) => {
    const id = firebase.default.auth().currentUser.uid
    const redirect = payload.redirect
    if (redirect) {
      const sendUser = {
        user: id,
        redirect: redirect
      }
      dispatch('checkUser', sendUser)
    } else {
      const update = { redirect: firebase.default.firestore.FieldValue.delete() }
      userRef.doc(id).update(update)
    }
  }
}

const getters = {
  userLoading: state => {
    return state.userLoading
  },
  user: state => {
    return state.users
  },
  users: state => {
    return state.users
  }
}

export default {
  state,
  mutations,
  actions,
  getters
}
